import { useEffect, useState } from 'react'
import './App.css';
import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firestore'

function sanitizeTwitterHandle(handle) {
  return handle.slice(0, 1) === '@'
    ? handle.slice(1)
    : handle
}

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyAxYVfLfOwA7e_9njOHgKjP5XrPuzzAlzw",
    authDomain: "twitter-friendcatcher.firebaseapp.com",
    projectId: "twitter-friendcatcher",
    storageBucket: "twitter-friendcatcher.appspot.com",
    messagingSenderId: "568172268311",
    appId: "1:568172268311:web:f1551f2fcfe5f822f4c552",
    measurementId: "G-7GJW7FBG6S"
  })
}else {
  firebase.app(); // if already initialized, use that one
}

const analytics = firebase.analytics()
const auth = firebase.auth()
const firestore = firebase.firestore()
const functions = firebase.functions()

// uncomment for local testing
// functions.useEmulator("localhost", 5001);

function Spinner() {
  return (
    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-light-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  )
}

function FriendCard(props) {
  const { friend } = props

  const addDefaultBanner = (ev) => {
    ev.target.src = friend.profile_background_image_url_https
  }

  return (
    <a href={`https://twitter.com/${friend.screen_name}`} target="_blank" rel="noreferrer">
      <div className="bg-white shadow-md rounded-md w-72 sm:w-96 mb-6 pb-2">
        <div className="rounded-t-md">
          <img
            className="rounded-t-md"
            src={friend.profile_banner_url}
            alt="banner"
            onError={addDefaultBanner}
          />
          <img className="rounded-full h-16 w-16 border-2 border-white -mt-8 ml-4" src={friend.profile_image_url_https} alt="propic" />
        </div>

        <div className="ml-4 flex flex-col items-start text-left">
          <div className="font-bold">{friend.name}</div>
          <div className="text-xs text-gray-500 mb-2">@{friend.screen_name}</div>
          <div className="text-xs">{friend.description}</div>
        </div>
      </div>
    </a>
  )
}

const errorMessageMap = {
  "Too many requests": (error, currentUser) => {
    const { rateLimitReset } = error
    const resetDate = new Date(rateLimitReset * 1000)
    const now = new Date()

    const diffInMillis = resetDate - now
    const minutesTillReset = Math.ceil(
      Math.floor(diffInMillis / 1000) / 60
    )

    return (
      'Sorry! We ran over the rate limit'
        + ' for the Twitter API free tier 😔.\n\n'
        + `The rate limit will reset in ${minutesTillReset} minutes.\n\n`
        + (currentUser ? '' : 'Sign in to increase your rate limit.')
    )
  }
}

function defaultRenderError(error) {
  return error.message
}

function App() {
  const [currentUser, setCurrentUser] = useState(null)

  const [theirHandle, setTheirHandle] = useState('')
  const [myHandle, setMyHandle] = useState('')
  const [newFriends, setNewFriends] = useState([])
  const [loading, setLoading] = useState(false)
  const [onlyNewMutuals, setOnlyNewMutuals] = useState(true)
  const [error, setError] = useState(null)

  auth.onAuthStateChanged((user) => {
    setCurrentUser(user)
  })

  useEffect(() => {
    firebase.auth()
      .getRedirectResult()
      .then((result) => {
        if (result.credential) {
          const credential = result.credential;
          const token = credential.accessToken;
          const secret = credential.secret;

          firestore.doc(`users/${result.user.uid}`).set({
            token, secret
          })
        }

	// setCurrentUser(result.user)
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...

        console.log('error', error)
      });
  }, [])

  const handleTwitterSignIn = () => {
    const provider = new firebase.auth.TwitterAuthProvider()
    firebase.auth().signInWithRedirect(provider)
  }

  const handleSignOut = () => {
    auth.signOut().then(() => {
      setCurrentUser({})
    })
  }

  const onSubmit = async (event) => {
    event.preventDefault()

    if (theirHandle === '' || myHandle === '') {
      setError('Please fill out both fields')
      return
    }

    // clear old friends list
    setNewFriends([])

    // clear error messages
    setError(null)
    
    const sanitizedTheirHandle = sanitizeTwitterHandle(theirHandle)
    const sanitizedMyHandle    = sanitizeTwitterHandle(myHandle)

    setLoading(true)

    const { token, secret } = currentUser
      ? (
          await firestore.doc(`users/${currentUser.uid}`)
            .get()
        ).data()
      : { token: null, secret: null }

    const getFriendsWhoFollowMe = functions.httpsCallable('getFriendsWhoFollowMe')
    getFriendsWhoFollowMe({
      theirHandle: sanitizedTheirHandle,
      myHandle: sanitizedMyHandle,
      onlyNewMutuals,
      userToken: token,
      userSecret: secret
    })
      .then(result => {
        if (result.data.error) {
          const error = JSON.parse(result.data.error)
          const renderError = errorMessageMap[error.message] || defaultRenderError
          setError(renderError(error, currentUser))
        } else {
          if (result.data.friendsWhoFollowMe.length === 0) {
            setError('No matches')
          }
          setNewFriends(result.data.friendsWhoFollowMe)
        }
	setLoading(false)
      })
      .catch(error => {
        console.log(error)
      })
  }

  return (
    <div className="min-h-screen bg-light-blue-500 p-4 flex flex-col items-center">
      <div className="w-72 sm:w-96 grid grid-flow-col grid-cols-3 mb-6">
        <div className="flex flex-col items-start col-span-2">
          <span className="text-white text-xs mb-2">
            Built with ❤️ by
            <a
              href="https://twitter.com/mattroll_"
              className="ml-1"
              target="_blank"
              rel="noreferrer">
              @mattroll_
            </a>
          </span>

          <a
            className="flex justify-center"
            href="https://www.buymeacoffee.com/mattroll"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
              className="h-8"
              alt="buymeacoffee"
            />
          </a>
        </div>

        <div className="flex items-start justify-end">
          <button
            className="bg-white text-light-blue-500 text-sm font-bold px-4 py-2 shadow-md rounded-md"
            onClick={currentUser ? handleSignOut : handleTwitterSignIn}
          >
            Sign {currentUser ? 'Out' : 'In'}
          </button>
        </div>
      </div>

      <div className="flex flex-col items-center w-full">
        <form onSubmit={onSubmit} spellCheck="false">
          <div className="mb-8 flex flex-col items-center">
            <div>
              <div className="text-white text-2xl sm:text-4xl font-bold">
                Find people who
              </div>

              <input
                type="text"
                value={theirHandle}
                onChange={e => setTheirHandle(e.target.value)}
                placeholder="Twitter handle (ex. jack)"
                className="bg-light-blue-500 border-b-4 border-white text-white text-lg p-2 pl-0 mb-2 w-72 sm:w-96 focus:outline-none placeholder-white placeholder-opacity-60"
              />
            </div>

            <div>
              <div className="text-white text-2xl sm:text-4xl font-bold">
                follows who also follow
              </div>

              <input
                type="text"
                value={myHandle}
                onChange={e => setMyHandle(e.target.value)}
                placeholder="My Twitter handle"
                className="bg-light-blue-500 border-b-4 border-white text-white text-lg p-2 pl-0 mb-4 w-72 sm:w-96 focus:outline-none placeholder-white placeholder-opacity-60"
              />
            </div>

            <div className="flex justify-start items-center w-72 sm:w-96 mb-2">
              <input
                type="checkbox"
                id="A3-yes"
                name="A3-confirmation"
                checked={onlyNewMutuals}
                onChange={e => {console.log(e.target.checked); setOnlyNewMutuals(e.target.checked)}}
                className="opacity-0 absolute h-8 w-8 cursor-pointer"
              />
              <div className="bg-white rounded-md w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
                <svg className="fill-current hidden w-3 h-3 text-blue-600 pointer-events-none" version="1.1" viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg">
              	<g fill="none" fillRule="evenodd">
              	  <g transform="translate(-9 -11)" fill="#1F73F1" fillRule="nonzero">
                    <path
                      d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z"
                    />
              	  </g>
              	</g>
                </svg>
              </div>
              <label htmlFor="A3-yes" className="select-none text-white text-sm">Show only potential new mutuals</label>
            </div>

            <button
              type="submit"
              className="bg-white text-light-blue-500 font-bold px-4 py-2 shadow-md rounded-md w-72 sm:w-96 flex justify-center"
            >
              {
                loading ? <Spinner /> : "Search"
              }
            </button>
          </div>
        </form>

        <div className="min-w-36 flex flex-col items-center">
          {
            error && <pre className="text-red-200 w-72 sm:w-96 whitespace-pre-wrap">{error}</pre>
          }

          {
            newFriends.map(friend => (
              <FriendCard key={friend.id} friend={friend} />
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default App;
